<template>
  <div class="l-content-inner">
    <!-- D: 출고현황 내역상세 -->
    <MoShipmentListDetail v-if="isVisible" />
    <!-- D: 매입현황 내역상세 -->
    <MoPurchaseListDetail v-else />
  </div>
</template>
<script>
import MoShipmentListDetail from "@/components/paintpro/order/moShipmentListDetail.vue";
import MoPurchaseListDetail from "@/components/paintpro/order/moPurchaseListDetail.vue";
export default {
  components: {
    MoShipmentListDetail,
    MoPurchaseListDetail,
  },
  data: () => ({
    isVisible: true,
  }),
};
</script>
